<template>
  <div>
    <FlotoPageHeader use-divider :title="`${$tc('variance')}`" />
    <FlotoCrudContainer
      ref="list"
      as-table
      prepend-new-item
      :scrollable="false"
      :fetch-fn="getSummaryVariances"
      :columns="tableColumns"
      :disabled="disabled"
      selectable
    >
      <template v-if="!disabled" v-slot:bulk-actions="slotData">
        <BulkActions
          v-bind="slotData"
          :resource="resource"
          :resource-id="resourceId"
          :variance="variance"
          @refresh="refresh"
        />
      </template>
      <template v-slot:createdTime="{ item }">
        <td class="text-ellipsis">
          <span v-if="item.createdTime">
            {{ item.createdTime | datetime }}
          </span>
          <span v-else>---</span>
        </td>
      </template>
      <template v-slot:componentModel="{ item }">
        <td class="text-ellipsis">
          {{ item.componentModel ? __tc(item.componentModel) : '---' }}
          {{ item.componentName ? `(${item.componentName})` : '' }}
        </td>
      </template>
      <template v-slot:fieldName="{ item }">
        <td class="text-ellipsis">
          {{
            (availableColumns.find((c) => c.key === item.fieldName) || {}).text
          }}
        </td>
      </template>
      <template v-slot:fromValue="{ item }">
        <td class="text-ellipsis">
          <AttributeFieldElement
            disabled
            :column="availableColumns.find((c) => c.key === item.fieldName)"
            :item="prepareItem(item, item.fromValue)"
          />
        </td>
      </template>
      <template v-slot:toValue="{ item }">
        <td class="text-ellipsis">
          <AttributeFieldElement
            disabled
            :column="availableColumns.find((c) => c.key === item.fieldName)"
            :item="prepareItem(item, item.toValue)"
          />
        </td>
      </template>
      <template v-slot:rejectChangeName="{ item }">
        <td class="text-ellipsis">
          <span v-if="item.rejectChangeName">
            <ResourceListTitle
              :name="item.rejectChangeName"
              open-in-new-tab
              :link="
                $modules.getModuleRoute('ticket', 'view', {
                  params: {
                    id: item.rejectChangeId,
                    ticketType: $constants.CHANGE,
                  },
                })
              "
            />
          </span>
          <span v-else>---</span>
        </td>
      </template>
      <template v-slot:actions="{ item }">
        <td class="text-ellipsis">
          <div v-if="!disabled" style="display: inline-flex">
            <VarianceApprovalDrawer
              :item="item"
              :resource="resource"
              :resource-id="resourceId"
              :variance="variance"
              @refresh="refresh"
            />
            <VarianceRejectionDrawer
              :item="item"
              :resource="resource"
              :resource-id="resourceId"
              :variance="variance"
              @refresh="refresh"
            />
          </div>
        </td>
      </template>
    </FlotoCrudContainer>
  </div>
</template>
<script>
// import CloneDeep from 'lodash/cloneDeep'
import {
  buildFlatQualificationStructure,
  buildRelationalQualificationStructure,
} from '@data/qualification'
import AttributeFieldElement from '@components/baseline-attribute-component/baseline-attribute-field-element'
import { getSupportedDataApi } from '@modules/asset-management/api/manage-baseline-api'
import ResourceListTitle from '@components/resource/resource-list-title'
import { transformRuleValue } from '@data/baseline'
import { getSummaryVariancesApi } from '../../../asset-api'
import VarianceApprovalDrawer from './variance-approval-drawer'
import VarianceRejectionDrawer from './variance-rejection-drawer'
import BulkActions from './bulk-actions'

export default {
  name: 'VarianceList',
  components: {
    VarianceApprovalDrawer,
    AttributeFieldElement,
    VarianceRejectionDrawer,
    BulkActions,
    ResourceListTitle,
  },
  props: {
    resourceId: { type: Number, required: true },
    resource: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    this.tableColumns = [
      {
        name: `${this.$tc('created_date')}`,
        key: 'createdTime',
        width: '150px',
        minWidth: '150px',
      },
      {
        name: `${this.$tc('asset')} ${this.$tc('component')}`,
        key: 'componentModel',
      },
      {
        name: `${this.$tc('attribute')} ${this.$tc('name')}`,
        key: 'fieldName',
      },
      {
        name: `${this.__tc('expected')} ${this.$tc('value')}`,
        key: 'fromValue',
      },
      {
        name: `${this.$tc('current')} ${this.$tc('value')}`,
        key: 'toValue',
      },
      {
        name: `${this.$tc('reference_rollback_request')} `,
        key: 'rejectChangeName',
      },
      {
        name: `${this.$tc('action', 2)}`,
        key: 'actions',
        width: '120px',
      },
    ]
    return {
      variance: {},
      availableColumns: [],
    }
  },
  created() {
    this.getSupportData()
  },
  methods: {
    getSupportData() {
      getSupportedDataApi().then((data) => {
        this.availableColumns = data.items
      })
    },
    refresh() {
      this.$refs.list.refresh()
      this.$emit('refresh')
    },
    getSummaryVariances(limit, offset) {
      // const criterias = CloneDeep(searchCriterias)
      // const q = buildFlatQualificationStructure([
      //   buildRelationalQualificationStructure(
      //     'status',
      //     'in',
      //      ['unapproved', 'rejected_pending'],,
      //     'enum',
      //     'db'
      //   ),
      // ])
      // criterias.quals.push(q)
      return getSummaryVariancesApi(
        this.resourceId,
        {
          qualDetails: buildFlatQualificationStructure([
            buildRelationalQualificationStructure(
              'status',
              'in',
              ['unapproved', 'rejected_pending'],
              'enum',
              'db'
            ),
          ]),
        },
        limit,
        offset
      ).then((data) => {
        this.variance = data.items
        return {
          ...data,
          items: data.items.map((i) => ({
            ...i,
            disableSelection: i.status === 'rejected_pending',
          })),
        }
      })
    },

    prepareItem(item, value) {
      let itemData = {
        ...(this.availableColumns.find((c) => c.key === item.fieldName) || {}),
        value: transformRuleValue(value, item.fieldName),
      }
      return itemData
    },
  },
}
</script>
